const LoginIcons = {
  bg: require('./img/login-bg.jpg'),
  fb: require('./img/facebook.svg'),
  google: require('./img/google.svg'),
};

const HeaderIcons = {
  logo: require('./img/logo.svg'),
  logosmartyellowdots: require('./img/logosmartyellowdots.svg'),
  logoWhite: require('./img/logo-white.svg'),
  search: require('./img/search.png'),
  bell: require('./img/bell.svg'),
  notificationBadge: require('./img/notification.svg'),
  notification: require('./img/notificationNew.svg'),
  bell_notify: require('./img/bell_notify.svg'),
  user: require('./img/user.svg'),
  menuHandlerOpen: require('./img/menuHandlerOpen.svg'),
};

const SidebarIcons = {
  Dashboard: require('./img/sidebar/dashboard.svg'),
  inbox: require('./img/sidebar/inbox.svg'),
  Search: require('./img/sidebar/smart.svg'),
  Request: require('./img/sidebar/requests.svg'),
  arrowcurcle: require('./img/sidebar/arrowcurcle.svg'),
  Orders: require('./img/sidebar/orders.svg'),
  Inventory: require('./img/sidebar/inventory.svg'),
  Archive: require('./img/sidebar/archive.svg'),
  Report: require('./img/sidebar/report.svg'),
  Members: require('./img/sidebar/members.svg'),
  Content: require('./img/sidebar/content.svg'),
  Chat: require('./img/sidebar/chat.svg'),
  Ports: require('./img/sidebar/ports.svg'),
  GateSchedule: require('./img/sidebar/gateschedule.svg'),
  Finance: require('./img/sidebar/finance.svg'),
  Integration: require('./img/sidebar/integration.svg'),
  Developer: require('./img/sidebar/developer.svg'),
  Update: require('./img/sidebar/update.svg'),
  Docs: require('./img/sidebar/docs.svg'),
  Logs: require('./img/sidebar/logs.svg'),
  alertadd: require('./img/alertadd.svg'),
  menuHandler: require('./img/menuHandler.svg'),
  homeIcon: require('./img/homeIcon.svg'),
  searchIcon: require('./img/searchIcon.svg'),
  inboxIcon: require('./img/inboxIcon.svg'),
  inventoryIcon: require('./img/inventoryIcon.svg'),
  reportIcon: require('./img/reportIcon.svg'),
  scheduleIcon: require('./img/scheduleIcon.svg'),
  inHouseIcon: require('./img/inHouseIcon.svg'),
  AppointmentIcon: require('./img/AppointmentIcon.svg'),
  autobook: require('./img/autobook.svg'),

  MembersNew: require('./img/sidebar/membersNew.svg'),
  ContentNew: require('./img/sidebar/contentNew.svg'),
  ExportNew: require('./img/sidebar/exportNew.svg'),
  ChatNew: require('./img/sidebar/chatNew.svg'),
  FinanceNew: require('./img/sidebar/financeNew.svg'),
  IntegrationNew: require('./img/sidebar/integrationNew.svg'),
  FeatureNew: require('./img/sidebar/featureNew.svg'),
  AiNew: require('./img/sidebar/aiNew.svg'),
  AlertsNew: require('./img/sidebar/AlertsNew.svg'),
  LogsNew: require('./img/sidebar/logsNew.svg'),
  DocsNew: require('./img/sidebar/docsNew.svg'),
  newAppt: require('./img/sidebar/new-appt.svg'),
  apptsList: require('./img/sidebar/appts-list.svg'),
  inhouse: require('./img/sidebar/inhouse.svg'),
};

const ChatBarIcons = {
  archive: require('./img/chatbar/archive.svg'),
  chat: require('./img/chatbar/chat.svg'),
  chatNew: require('./img/chatbar/chatNew.svg'),
  chat_notify: require('./img/chatbar/chat_notify.svg'),
  support: require('./img/chatbar/support.svg'),
  sendIcon: require('./img/chatbar/sendIcon.svg'),
  fileIcon: require('./img/chatbar/fileIcon.svg'),
  emojiIcon: require('./img/chatbar/emojiIcon.svg'),
  AI: require('./img/chatbar/AI.svg'),
};

const Icons = {
  container: require('./img/container.png'),
  filter: require('./img/filter.svg'),
  truck: require('./img/truck.svg'),
  welcome: require('./img/welcome.jpg'),
  tickICon: require('./img/tick.svg'),
  borderedTick: require('./img/bordered-tick.svg'),
  emptyTickContainer: require('./img/tick-container.svg'),
  has_containers_empty: require('./img/has-containers-empty.svg'),
  has_containers_half: require('./img/has_containers_half.svg'),
  has_containers_full: require('./img/has_containers_full.svg'),
  has_containers: require('./img/has_containers.svg'),
  website_icon: require('./img/website.svg'),
  restraction_icon: require('./img/examption.svg'),
  examption_icon: require('./img/restriction.svg'),
  locationMap: require('./img/location.png'),
  dayDateHighlight: require('./img/dayDateHighlight.svg'),
  dayDateHighlightDate: require('./img/dayDateHighlightDate.svg'),
  xiconn: require('./img/xiconn.svg'),
  xiconnnn: require('./img/xiconnnn.svg'),
  close: require('./img/close.svg'),
  closeIcon: require('./img/closeIcon.svg'),
  arrowTop: require('./img/arrowTop.svg'),
  arrowDown: require('./img/arrowDown.svg'),
  arrowDownProfile: require('./img/arrowDownProfile.svg'),
  sortNew: require('./img/SortNew.svg'),
  sortedNewUp: require('./img/SortedNewUp.svg'),
  sortedNewDown: require('./img/SortedNewDown.svg'),
  transaction: require('./img/transaction.svg'),
  message: require('./img/HoverIcon.svg'),
  attention: require('./img/attention.svg'),
  WhatsApp: require('./img/whatsapp.svg'),
  directMessage: require('./img/directMessage.svg'),
  pendingIcon: require('./img/pending.svg'),
  checkIcon: require('./img/check-symbol-4794.svg'),
  rejectIcon: require('./img/rejected.svg'),
  userProfileIcon: require('./img/userProfile.svg'),
  passwordIcon: require('./img/password-lock-12.svg'),
  refreshIcon: require('./img/refresh-svgrepo-com.svg'),
  stop: require('./img/stop.svg'),
  stopRed: require('./img/stopred.svg'),
  options: require('./img/settinggg.svg'),
  dragdrop: require('./img/dragdrop.svg'),
  infoIcon: require('./img/information-icon.svg'),
  importIcon: require('./img/export.svg'),
  dicsount: require('./img/discount.svg'),
  forbidden: require('./img/forbidden.svg'),
  appointment: require('./img/appointment.svg'),
  appointmentBlack: require('./img/appointmentBlack.svg'),
  directInbox: require('./img/direct-inbox.svg'),
  arrowBack: require('./img/arrowBack.svg'),
  filterNew: require('./img/filterNew.svg'),
  newTick: require('./img/tickNew.svg'),
  newTickSkinny: require('./img/tickNewSkinny.svg'),
  clipboardTick: require('./img/clipboard-tick.svg'),
  infoCircle: require('./img/info-circle.svg'),
  infoCircleBlack: require('./img/info-circleBlack.svg'),
  infoCirclePending: require('./img/info-circlePending.svg'),
  emptyHandle: require('./img/EmptyState.svg'),
  emptySection: require('./img/emptySectionNew.svg'),
  emptySection: require('./img/emptySectionNew.svg'),
  emptyPending: require('./img/emptyPending.svg'),
  messageIconNew: require('./img/messages.svg'),
  fileSelect: require('./img/paperclip-2.svg'),
  sendMessage: require('./img/sendMessage.svg'),
  sendMessageBlack: require('./img/sendMessageBlack.svg'),
  clock: require('./img/clock.svg'),
  tickCircle: require('./img/tick-circle.svg'),
  xCircle: require('./img/close-circle.svg'),
  xIconBlack: require('./img/xIconBlack.svg'),
  arrowDownNew: require('./img/arrow-down.svg'),
  galleryAdd: require('./img/gallery-add.svg'),
  galleryAddBlue: require('./img/gallery-addBlue.svg'),
  galleryAddBlack: require('./img/gallery-addBlack.svg'),
  tickSquare: require('./img/tick-square.svg'),
  downVector: require('./img/Vectordown.svg'),
  upVector: require('./img/Vectorup.svg'),
  containerTruck: require('./img/truck-tick.svg'),
  imageUpload: require('./img/imageUpload.svg'),
  imageView: require('./img/eye.svg'),
  buildings: require('./img/buildings.svg'),
  callCalling: require('./img/call-calling.svg'),
  frame: require('./img/frame.svg'),
  sms: require('./img/sms.svg'),
  locationNew: require('./img/locationNew.svg'),
  locationInput: require('./img/locationInput.svg'),
  hoursSelect: require('./img/hourSelect.svg'),
  declineIcon: require('./img/declineIcon.svg'),
  CountdownTimerIcon: require('./img/CountdownTimerIcon.svg'),
  InstructionsIcon: require('./img/InstructionsIcon.svg'),
  SingleShift: require('./img/SingleShift.svg'),
  DualShift: require('./img/DualShift.svg'),
  calendarday: require('./img/calendarday.svg'),
  calendartime: require('./img/calendartime.svg'),
  clocktime: require('./img/clocktime.svg'),
  leftArrow: require('./img/leftArrow.svg'),
  rightArrow: require('./img/rightArrow.svg'),
  people: require('./img/people.svg'),
  redX: require('./img/redX.svg'),
  pen: require('./img/pen.svg'),
  penNew: require('./img/editNew.svg'),
  cancelCalendar: require('./img/cancelCalendar.svg'),
  screenshoteye: require('./img/screenshoteye.svg'),
  closeCircle: require('./img/closeCircle.svg'),
  calendarCog: require('./img/calendar-cog.svg'),
  history: require('./img/history.svg'),
  whiteBell: require('./img/whiteBell.svg'),
  whiteClose: require('./img/whiteClose.svg'),
  action: require('./img/action.svg'),
  licensePlate: require('./img/licensePlate.svg'),
  readAll: require('./img/readAll.svg'),
  mute: require('./img/mute.svg'),
  unMute: require('./img/unMute.svg'),
  dotBlue: require('./img/dotBlue.svg'),
  arrowUp: require('./img/arrow-up.svg'),
  containerIcon: require('./img/containerIcon.svg'),
  autobookContainer: require('./img/autobookContainer.svg'),
  autobookList: require('./img/autobookList.svg'),
  loadData: require('./img/loadData.svg'),
  saveData: require('./img/saveData.svg'),
  historyList: require('./img/historyList.svg'),
  infoEmptyList: require('./img/infoEmptyList.svg'),
  deleteIcon: require('./img/deleteIcon.svg'),
  editIcon: require('./img/editIcon.svg'),
  moreHorizontal: require('./img/moreHorizontal.svg'),
  addItem: require('./img/addItem.svg'),
  Add: require('./img/Add.svg'),
  trashIcon: require('./img/trashIcon.svg'),
  searchIcon: require('./img/searchIcon.svg'),
  defaultAvatar: require('./img/default-avatar.png'),
  inventoryAptNotAvail: require('./img/inventoryAptNotAvail.svg'),
  inventoryAptAutobook: require('./img/inventoryAptAutobook.svg'),
  AptAutobookActive: require('./img/AptAutobookActive.svg'),
  AptAutobook: require('./img/AptAutobook.svg'),
  inventoryAptBook: require('./img/inventoryAptBook.svg'),
  autobookCollector: require('./img/autobookCollector.svg'),
  singleUser: require('./img/singleUser.svg'),
  company: require('./img/company.svg'),
  clock2: require('./img/clock2.svg'),
  loading: require('./img/loading.svg'),
  setting: require('./img/setting.svg'),
  eye: require('./img/eye-simple.svg'),
  eyeClose: require('./img/eye-close.svg'),
  arrowUpSmall: require('./img/arrow-up-small.svg'),
  lock: require('./img/lock.svg'),
  phoneProfile: require('./img/phone-profile.svg'),
  mailProfile: require('./img/mail-profile.svg'),
  mapPin: require('./img/map-pin.svg'),
  buildingProfile: require('./img/building-profile.svg'),
  minusSquare: require('./img/minus-square.svg'),
  plusSquare: require('./img/plus-square.svg'),
  infoGray: require('./img/info-gray.svg'),
  halfCircle: require('./img/half-circle.svg'),
  circleCheck: require('./img/circle-check.svg'),
  circleX: require('./img/circle-x.svg'),
  timeFile: require('./img/time-file.svg'),
  checkTick: require('./img/check-tick.svg'),
  link: require('./img/link.svg'),
  copy: require('./img/copy.svg'),
  gem: require('./img/gem.svg'),
  emptyCalendar: require('./img/empty-calendar.svg'),
  polygon: require('./img/polygon.svg'),
  payPal: require('./img/PayPal.svg'),
  visa: require('./img/Visa.svg'),
  download: require('./img/download.svg'),
  smallCheck: require('./img/small-check.svg'),
  tickAppointment: require('./img/tickAppointment.svg'),
  loadingIndicator: require('./img/loading/SmartNewLoading.svg'),
  loadingIndicatorGray: require('./img/loading/SmartNewLoadingGray.svg'),
  yourInventory: require('./img/YourEmpty.svg'),
  exportXLSXIcon: require('./img/exportXLSXIcon.svg'),
  addInventoryIcon: require('./img/addInventoryIcon.svg'),
  closeMsg: require('./img/closeMsg.svg'),
  closeMsgActive: require('./img/closeMsgActive.svg'),
  dualMsg: require('./img/dualMsg.svg'),
  dualMsgActive: require('./img/dualMsgActive.svg'),
  openMsg: require('./img/openMsg.svg'),
  openMsgActive: require('./img/openMsgActive.svg'),
  whiteLinePattern: require('./img/white-line-pattern.png'),
  list: require('./img/list.svg'),
  grid: require('./img/grid.svg'),
  rightBlueArrow: require('./img/right-blue-arrow.svg'),
  liveMap: require('./img/live-map.svg'),
  searchList: require('./img/search-list.svg'),
  searchTick: require('./img/search-tick.svg'),
  tooltipInfo: require('./img/TooltipInfo.svg'),
  locMap: require('./img/locMap.svg'),
  timeBack: require('./img/time-back.svg'),
  autobookAppt: require('./img/autobook-appt.svg'),
  dangerInfo: require('./img/danger-info.svg'),
  ticket: require('./img/ticket.svg'),
  share: require('./img/share.svg'),
  questionMark: require('./img/question-mark.svg'),
  contactSupport: require('./img/contact-support.svg'),
  videoPlay: require('./img/video-play.svg'),
  users: require('./img/users.svg'),
  videoPlayFile: require('./img/video-play-file.svg'),
};

const DashboardIcons = {
  arrowBlack: require('./img/dash/arrow-b.svg'),
  arrowWhite: require('./img/dash/arrow-w.svg'),
  welcome: require('./img/dash/welcome.jpg'),
};

const ContainerIcons = [
  require('./img/container/1.svg'),
  require('./img/container/2.svg'),
  require('./img/container/3.svg'),
  require('./img/container/4.svg'),
];

const NewContainerIcons = {
  MSC: require('./img/container/MSC.svg'),
  ZIM: require('./img/container/ZIM.svg'),
  WANHAI: require('./img/container/WAN HAI.svg'),
  EVERGREEN: require('./img/container/EVERGREEN.svg'),
  ONE: require('./img/container/ONE.svg'),
  YANGMING: require('./img/container/YANG MING.svg'),
  OOCL: require('./img/container/OOCL.svg'),
  COSCO: require('./img/container/COSCO.svg'),
  'CMA-CGM': require('./img/container/CMA-CGM.svg'),
  HYUNDAI: require('./img/container/HYUNDAI.svg'),
  MAERSK: require('./img/container/MAERSK.svg'),
  SMLINE: require('./img/container/SM-LINE.svg'),
  PIL: require('./img/container/PIL.svg'),
  SAFMARINE: require('./img/container/SAF-MARINE.svg'),
  SEALAND: require('./img/container/SEA-LAND.svg'),
  'HAPAG-LLOYD': require('./img/container/HAPAG-LLOYD.svg'),
  TSLINE: require('./img/container/TS-LINE.svg'),
  ANL: require('./img/container/ANL.svg'),
  BAL: require('./img/container/BAL.svg'),
  MATSON: require('./img/container/MATSON.svg'),
  defaultOrangeContainer: require('./img/container/defaultOrangeContainer.svg'),
};

const LandingIcon = {
  appstore: require('./img/Landing/appstore.svg'),
  google: require('./img/Landing/google.svg'),
  Bg: require('./img/Landing/landing-bg.jpg'),
  App: require('./img/Landing/app-image.png'),
  pattern: require('./img/Landing/pattern.png'),
  whatsapp: require('./img/Landing/whatsapp.svg'),
  facebook: require('./img/Landing/facebook.svg'),
  instagram: require('./img/Landing/instagram.svg'),
  linkedin: require('./img/Landing/linkedin.svg'),
};

const ContactBg = require('./img/contact-bg.jpg');
const AboutBg = require('./img/about-bg.jpg');
const WhatsappBg = require('./img/wpback.jpg');

export const HowIcons = {
  container: require('./img/how/container.svg'),
  custom: require('./img/how/custom.svg'),
};

export const HowSteps = {
  final: require('./img/how/steps/final.jpg'),
  inv: require('./img/how/steps/inv.jpg'),
  req: require('./img/how/steps/req.jpg'),
  sign: require('./img/how/steps/sign.jpg'),
  search: require('./img/how/steps/search.jpg'),
};

const MemberIcons = {
  addMember: require('./img/addMember.svg'),
  editMember: require('./img/edit.svg'),
  deleteMember: require('./img/trash.svg'),
  verifyMember: require('./img/email.svg'),
  search: require('./img/search.svg'),
};

const AdminTopMenuIcons = {
  dashboard: require('./img/adminTopMenu/dashboard.svg'),
  smartSearch: require('./img/adminTopMenu/smart-search.svg'),
  inventory: require('./img/adminTopMenu/inventory.svg'),
  orders: require('./img/adminTopMenu/orders.svg'),
  request: require('./img/adminTopMenu/request.svg'),
  report: require('./img/adminTopMenu/report.svg'),
};

const TerminalsIcon = {
  EVERPORT: require('./img/terminals/EVERPORT.png'),
  FMS: require('./img/terminals/FMS.png'),
  LACT: require('./img/terminals/LACT.png'),
  PCT: require('./img/terminals/PCT.png'),
  PST: require('./img/terminals/PST.png'),
  TRAPAC: require('./img/terminals/TRAPAC.png'),
  WBCT: require('./img/terminals/WBCT.png'),
  WCC: require('./img/terminals/WCC.png'),
  YTI: require('./img/terminals/YTI.png'),
  APM: require('./img/terminals/APM.png'),
  LBCT: require('./img/terminals/LBCT.png'),
  TTI: require('./img/terminals/TTI.png'),
  ITS: require('./img/terminals/ITS.png'),
  MATSON: require('./img/terminals/MATSON.png'),
  SSA: require('./img/terminals/SSA.png'),
  SSAMARINE: require('./img/terminals/SSA.png'),
  'SSA MARINE': require('./img/terminals/SSA.png'),
  STL: require('./img/terminals/STL.png'),
  PTS: require('./img/terminals/PTS.png'),
  PierPass: require('./img/terminals/PierPass.jpeg'),
  YTILynx: require('./img/terminals/YTILynx.png'),
  Emodal: require('./img/terminals/eModal.png'),
  ShippersLongBeach: require('./img/terminals/ShippersLongBeach.png'),
  ShippersExpress: require('./img/terminals/ShippersExpress.png'),
  YTIGateLink: require('./img/terminals/YTIGateLink.png'),
  PierA: require('./img/terminals/PierA.png'),
};

export {
  LoginIcons,
  HeaderIcons,
  SidebarIcons,
  ChatBarIcons,
  TerminalsIcon,
  Icons,
  DashboardIcons,
  ContainerIcons,
  LandingIcon,
  MemberIcons,
  AdminTopMenuIcons,
  ContactBg,
  AboutBg,
  WhatsappBg,
  NewContainerIcons,
};
